<ng-container *ngIf="data$ | async as data">
  <div
    *ngIf="data.content"
    [innerHtml]="data.content | htmlSanitize: 'html'"
    >
  </div>
</ng-container>
